/* Pichea Home — reveals on scroll + hero word-stagger + quiz de vibras
   Motion estilo Emil Kowalski: rápido, calmado, sin bounce.
   Cada elemento anima una sola vez. Respeta prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__pihLoaded) return;
  window.__pihLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) document.documentElement.classList.add('pih-motion');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('pih-on');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });

  function scan(root) {
    (root || document).querySelectorAll('[data-pih-reveal]:not(.pih-on)').forEach(function (el) {
      io.observe(el);
    });
  }

  function heroOn() {
    requestAnimationFrame(function () {
      document.documentElement.classList.add('pih-hero-on');
    });
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.pih-section video').forEach(function (v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* Quiz "¿Cuál es tu vibra hoy?" — pills + re-stagger de cards al cambiar */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-pih-quiz]').forEach(function (quiz) {
      if (quiz.dataset.pihInit) return;
      quiz.dataset.pihInit = '1';
      var pills = quiz.querySelectorAll('[data-pih-vibe]');
      var panels = quiz.querySelectorAll('[data-pih-panel]');

      function show(key) {
        pills.forEach(function (p) {
          p.classList.toggle('pih-pill--active', p.dataset.pihVibe === key);
          p.setAttribute('aria-selected', p.dataset.pihVibe === key ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.pihPanel === key;
          panel.hidden = !active;
          if (active) {
            panel.querySelectorAll('[data-pih-reveal]').forEach(function (card, i) {
              card.classList.remove('pih-on');
              card.style.setProperty('--d', (i * 0.08) + 's');
            });
            /* forzar reflow para que la transición re-dispare */
            void panel.offsetWidth;
            panel.querySelectorAll('[data-pih-reveal]').forEach(function (card) {
              card.classList.add('pih-on');
            });
          }
        });
      }

      pills.forEach(function (p) {
        p.addEventListener('click', function () { show(p.dataset.pihVibe); });
      });
      if (pills.length) show(pills[0].dataset.pihVibe);
    });
  }

  function init() {
    scan();
    heroOn();
    initVideos();
    initQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-scan al recargar secciones en el theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    initVideos(e.target);
    initQuiz(e.target);
  });
})();
